import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { findHotelDestination } from '../../actions/Booking';
import { getLangValue } from '../../utils/Generic';

import BtnEdit from '../ds/atoms/btn/btnEdit';
import DsBookingSummary from '../ds/organism/BookingSummary';
import '../../static/less/booking_form_summary.less';

class BookingFormSummary extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      hotelName: this.loadHotelName(props),
    };
  }

  getHotelCode(props) {
    const lastInfo = props.lastInfo || {};
    const hotels = lastInfo.hotels || [];
    return hotels.length === 0 ? '' : hotels[0];
  }

  loadHotelName(props) {
    const hotelCode = this.getHotelCode(props);
    if (hotelCode === '') {
      return '';
    }
    const countries = props.countries || [];
    const fullHotel = findHotelDestination(countries, hotelCode);
    return getLangValue(fullHotel, this.props.lang, 'name');
  }

  render() {
    if (!this.props.lastInfo.checkin) {
      return null;
    }
    const {
      lastInfo, distributions,
    } = this.props;

    let dist = null;
    if (distributions.distributions.length) {
      dist = distributions.distributions;
    }
    const {
      lang, chain,
    } = this.state;
    const dates = {
      checkIn: lastInfo.checkin,
      checkOut: lastInfo.checkout,
    };
    const hotel = this.state.hotelName || this.getHotelCode(this.props);
    return (
            <DsBookingSummary onClick={this.props.onEditClick}
                              hotel={hotel} dates={dates} distribution={dist}
                              lang={lang} chain={chain}
                              className="w-full justify-left md:justify-around pt-8 bordert-t">
              <BtnEdit onClick={this.props.onEditClick}/>
            </DsBookingSummary>
    );
  }
}

BookingFormSummary.propTypes = {
  onEditClick: PropTypes.func.isRequired,
};

BookingFormSummary.contextTypes = {
  t: PropTypes.func.isRequired,
};

export default connect((state) => ({
  chain: state.bookingFormState.chain,
  countries: state.bookingFormState.countries,
  step: state.booking.step,
  sessionId: state.bookingFormState.sessionId,
  device: state.bookingFormState.device,
  distributions: state.bookingFormState,
  lastInfo: state.booking.last_requested_info,
  lang: state.i18nState.lang,
}))(BookingFormSummary);
